import client from './client';

// List stores with optional filtering
export const listStores = async (params = {}) => {
  const res = await client.get('/stores', { params });
  return res.data;
};

// Remove a store
export const removeStore = async (storeId) => {
  const res = await client.get('/stores/store-remove', {
    params: { store: storeId }
  });
  return res.data;
};

// Get stores for a specific group
export const getStoresByGroup = async (groupId) => {
  const res = await client.get(`/groups/${groupId}/stores`);
  return res.data;
};

// Create a new store (if needed in future)
export const createStore = async (storeData) => {
  const res = await client.post('/stores', storeData);
  return res.data;
};

// Update a store (if needed in future)
export const updateStore = async (storeId, storeData) => {
  const res = await client.put(`/stores/${storeId}`, storeData);
  return res.data;
};

// Delete a store (if needed in future)
export const deleteStore = async (storeId) => {
  const res = await client.delete(`/stores/${storeId}`);
  return res.data;
};
